import { render, staticRenderFns } from "./WebhookConfig.vue?vue&type=template&id=2baa91b0&scoped=true"
import script from "./WebhookConfig.vue?vue&type=script&lang=js"
export * from "./WebhookConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baa91b0",
  null
  
)

export default component.exports